import { invokeEdgeOrPresent } from '../../shared/supabase/invokeEdgeOrPresent';
import { FiscalPadronError } from '../domain/fiscalErrors';
import type { PadronResult } from '../domain/fiscalTypes';
import { parseSupabaseInvokeError } from './parseSupabaseInvokeError';

/** Consulta padrón AFIP/ARCA por CUIT (Edge arca-padron). */
export const consultaPadron = async (
  cuit: string,
  branchId?: string | null
): Promise<PadronResult> => {
  const { data, error, presented } = await invokeEdgeOrPresent('arca-padron', {
    body: { cuit: cuit.replace(/\D/g, ''), branch_id: branchId ?? null },
  }, {
    module: 'fiscal',
    op: 'fiscal.padron',
    fallbackMessage: 'Error al consultar padrón',
  });
  const body = (data ?? {}) as {
    cuit?: string;
    razon_social?: string;
    tax_condition?: number | null;
    from_cache?: boolean;
    sandbox?: boolean;
    error?: string;
    code?: string;
  };
  if (error || body?.error) {
    const code = body?.code?.trim() || 'FISCAL_PADRON_ERROR';
    if (presented) {
      throw new FiscalPadronError(body?.error ?? error?.message ?? 'No se pudo consultar el padrón. Reintentá.', code);
    }
    const message = await parseSupabaseInvokeError(
      error,
      'No se pudo consultar el padrón. Reintentá.',
      body?.error
    );
    throw new FiscalPadronError(message, code);
  }
  if (!body?.razon_social) throw new FiscalPadronError('No se obtuvo razón social');
  return {
    cuit: body.cuit ?? cuit,
    razonSocial: body.razon_social,
    taxCondition: body.tax_condition ?? null,
    fromCache: body.from_cache,
    sandbox: body.sandbox,
  };
};
